import styled from "styled-components";

type TableRowProps = {
    $height?: string;
}
export const Table = styled.table`
    width: 100%;
    font-family: Poppins-Regular;
    border-collapse: collapse;
`;
export const TableRow = styled.tr<TableRowProps>`
    height: ${props => props.$height};
    border-bottom: 1px solid var(--main-light-grey-color);
`;
export const TableHeader = styled.thead`
    border-bottom: 2px solid var(--main-teal-color);
`;
export const FieldName = styled.td`
    padding:0.8em;
    font-size: 1.2rem;
    font-family: Lato-Bold;
`;
export const FieldData = styled.td`
    padding:0.8em;
    font-size: 1rem;
`;
export const FieldButton = styled.td`
    color: var(--main-teal-color);
    cursor:pointer;
    transition: 0.3s;
        :hover {
            color: var(--main-orange-color);
            transition: 0.3s;
`;
export const FullWidthCell = styled.td`
    text-align:center;
    font-size: 1rem;
    padding:2em;
`;